import React from 'react'
import { ActivityIndicator, Modal } from 'react-native'
import { Box, Stack, Text } from './index'

type LoaderProps = {
	visible: boolean
	message?: string
	actionButton?: React.ReactNode
	style?: Record<string, any>
}

export const Loader = ({ visible, message, actionButton, style }: LoaderProps) => {
	return (
		<Modal transparent={true} visible={visible} animationType="fade">
			<Box
				alignItems="center"
				justifyContent="center"
				style={{
					flex: 1,
					backgroundColor: 'rgba(0, 0, 0, 0.5)',
				}}
			>
				{message ? (
					<Box
						padding="lg"
						width="auto"
						borderRadius="medium"
						background="white"
						alignItems="center"
						style={{
							shadowColor: '#000',
							shadowOffset: {
								width: 0,
								height: 2,
							},
							shadowOpacity: 0.25,
							shadowRadius: 3.84,
							elevation: 5,
							...style,
						}}
					>
						<Stack align="center" gap="lg">
							<Stack align="center" gap="md">
								<ActivityIndicator size="large" color={global.orgColor} />
								<Text style={{ marginTop: 10 }} weight="medium" level="body">
									{message}
								</Text>
							</Stack>
							{actionButton}
						</Stack>
					</Box>
				) : (
					<Box>
						<ActivityIndicator size="large" color={global.orgColor} />
						{actionButton}
					</Box>
				)}
			</Box>
		</Modal>
	)
}
